// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"964f8404","148":"1ed4ac40","596":"3588172e","667":"91daf4b3","920":"3588172e"}[chunkId] + ".css";
};